import AOS from 'aos';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Routes, Route } from 'react-router-dom';

import Layout from './components/Layout/Layout';
import Landingpage from './components/Landingpage/Landingpage';
import PrivacyPlicy from './components/PrivacyPolicy/PrivacyPolicy';
import ScrollToHash from './hoc/ScrollRoHash';
/* import Home from './components/Home/Home';
import Features from './components/Features/Features';
import Gallery from './components/Gallery/Gallery';
import Download from './components/Download/Download';
import Booking from './components/Booking/Booking';
import HowItWork from './components/HowItWork/HowItWork';
import FeaturesTab from './components/FeaturesTab/FeaturesTab';
import Contact from './components/Contact/Contact'; */
import './App.css';
import 'aos/dist/aos.css';

function App() {
  const { i18n } = useTranslation();
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });

    const lang = i18n.resolvedLanguage || 'en';
    const dir = ['ar', 'he', 'fa', 'ur'].includes(lang) ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);
    document.documentElement.setAttribute('lang', lang);
    document.body.classList.remove('rtl', 'ltr');
    document.body.classList.add(lang === 'ar' ? 'rtl' : 'ltr');
  }, [i18n.resolvedLanguage]);

  return (
    <Layout>
      <ScrollToHash />
      <Routes>
        <Route path='/' element={<Landingpage />}/>
        <Route path='/privacy-policy' element={<PrivacyPlicy />}/>
      </Routes>
      {/* <Home />
      <Features />
      <FeaturesTab />
      <HowItWork />
      <Gallery />
      <Contact />
      <Download />
      <Booking /> */}
    </Layout>
  );
}

export default App;
